import type { ArgumentTypes } from 'types/utility';

/**
 * Prevent circular dependency issues
 */
export function lazySelector<T extends (...args: any) => any>(
  importPromise: Promise<T>
): (...args: ArgumentTypes<T>) => ReturnType<T> | null {
  let ref: T | null = null;
  // The import() is fired at module-evaluation time and never awaited. Under
  // test it can settle after the Vitest environment is torn down once a test
  // file finishes — that race is expected noise, so swallow it. Note this also
  // swallows a genuine module-load failure during a test run; it surfaces as
  // the selector returning null rather than an explicit error. Anywhere else
  // (dev/prod browser) a rejection means a genuine module/chunk load failure,
  // so rethrow to keep it surfacing as an unhandled rejection.
  importPromise
    .then(m => (ref = m))
    .catch(err => {
      if (process.env.NODE_ENV !== 'test') {
        throw err;
      }
    });
  return (...args) => {
    return ref ? ref(...args) : null;
  };
}
